// extracted by mini-css-extract-plugin
export var statItem = "_h7-1";
export var statsRow = "_h7-0";